import { useLingui } from '@lingui/react/macro';
import { type FC, memo, useRef } from 'react';
import { useCoin } from '@/shared/api';
import { ClientOnly } from '@/shared/ClientOnly';
import { Widget } from '@/shared/Widget';
import { useIsDark } from '@/theme/theme';

const CHART_HEIGHT = 360;

type CoinChartSectionProps = {
  slug?: string;
};

export const CoinChartSection: FC<CoinChartSectionProps> = memo(({ slug }) => {
  const { t } = useLingui();
  const { data: coin } = useCoin(slug?.toUpperCase());
  const isDark = useIsDark();
  const containerRef = useRef<HTMLDivElement>(null);

  const chartUrl = coin?.market_data?.chart_slug
    ? `https://s.tradingview.com/widgetembed/?symbol=${coin.market_data.chart_slug}&interval=60&theme=${isDark ? 'dark' : 'light'}&autosize`
    : null;

  return (
    <div ref={containerRef}>
      <Widget>
        <p className="text-lg text-content-primary font-medium mb-3">
          {`${coin?.name ?? ''} ${t`Price Chart`}`}
        </p>

        <div
          className="w-full"
          style={{
            height: CHART_HEIGHT,
            minHeight: CHART_HEIGHT,
            maxHeight: CHART_HEIGHT,
          }}
        >
          <div className="relative w-full h-full overflow-hidden">
            {chartUrl && coin?.market_data?.chart_slug ? (
              <ClientOnly>
                <iframe
                  src={chartUrl}
                  width="100%"
                  height={CHART_HEIGHT}
                  className="absolute inset-0"
                  allowFullScreen
                  loading="lazy"
                  key={chartUrl}
                  title={coin.market_data.chart_slug}
                />
              </ClientOnly>
            ) : null}
          </div>
        </div>
      </Widget>
    </div>
  );
});
